<template>
	<ul class="row" v-if="!basketSelect">
		<li
			class="col-6 col-sm-4 px-0"
			:class="{
				active: basket.shippingCountryId == shippingCountry.id,
				'is-disabled': isDisabled
			}"
			v-for="shippingCountry in filteredShippingCountries"
			:key="shippingCountry.id"
		>
			<a
				class="nav-link"
				data-toggle="collapse"
				href="#countrySettings"
				@click="setShippingCountry(shippingCountry.id)"
				:disabled="isDisabled"
				v-tooltip="isDisabled"
				data-boundary="window"
				:data-title="$translate('Ceres::Template.headerChangeDeliveryCountry')"
                :aria-label="$translate('Ceres::Template.headerChangeDeliveryCountry')"
			>
				<i :class="'flag-icon flag-icon-' + shippingCountry.isoCode2.toLowerCase()"></i>
				{{ shippingCountry.currLangName }}
			</a>
		</li>
	</ul>
	<div v-else>
		<div class="h3">
			{{ $translate("Ceres::Template.headerSelectShippingCountry") }}
		</div>
		<div class="select-tooltip own-tooltip" v-if="isVisibleTooltip">
			{{ $translate('Ceres::Template.headerChangeDeliveryCountry') }}
		</div>
		<div class="country-select-dropdown-wrapper"
		>
			<select
				v-if="filteredShippingCountries.length > 1"
				class="form-control"
				:class="{disabled: isDisabled}"
				@change="setShippingCountry($event.target.value)"
				v-tooltip="isDisabled"
				data-boundary="window"
				:data-title="$translate('Ceres::Template.headerChangeDeliveryCountry')"
			>
				<option
					v-for="shippingCountry in filteredShippingCountries"
					:value="shippingCountry.id"
					:disabled="isDisabled"
					:selected="basket.shippingCountryId == shippingCountry.id"
					:key="shippingCountry.id"
				>
					{{ shippingCountry.currLangName }}
				</option>
			</select>
			<div v-else>
				{{ getCountryName(localization.shippingCountryId) }}
			</div>
		</div>
	</div>
</template>

<script>
import { removeUrlParam } from "../../services/UrlService";
import { mapState, mapGetters } from "vuex";

export default {
	props: {
		disableInput: Boolean,
		openBasketPreview: Boolean,
		basketSelect: Boolean
	},

	computed: {
		isDisabled() {
			return (
				!!this.basket.customerInvoiceAddressId || !!this.basket.customerShippingAddressId || this.disableInput
			);
		},

		filteredShippingCountries() {
			return App.Eros.Config.general.visibleShippingCountries.length ? this.localization.shippingCountries.filter(shippingCountry => {
				return App.Eros.Config.general.visibleShippingCountries.includes(shippingCountry.isoCode2);
			}) : this.localization.shippingCountries;
		},

		...mapState({
			localization: (state) => state.localization,
			basket: (state) => state.basket.data
		}),

		...mapGetters(["getCountryName"])
	},

	data() {
		return {
			isVisibleTooltip: false
		}
	},

	beforeMount() {
		if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.components.pageDesign.ShippingCountrySelect: mount"); // eslint-disable-line no-console
	},

	mounted() {
		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.components.pageDesign.ShippingCountrySelect: mount"); // eslint-disable-line no-console
		removeUrlParam("openBasketPreview");
	},

	methods: {
		setShippingCountry(id) {
			if (!this.isDisabled) {
				this.$store.dispatch("selectShippingCountry", {
					shippingCountryId: id,
					openBasketPreview: this.openBasketPreview
				});
			}
		}
	}
};
</script>
